import { FC } from "react"
import { Outlet } from "react-router-dom"

export const RouteContainer: FC = () => {
	return (<Outlet />);
}